// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const impidimp: PokeData = {
  "id": 859,
  "name": "impidimp",
  "height": 4,
  "weight": 55,
  "base_experience": 53,
  "types": [
    PokeType.DARK,
    PokeType.FAIRY
  ],
  "api_moves": [
    "bite",
    "swagger",
    "fake-out",
    "torment",
    "flatter",
    "fake-tears",
    "assurance",
    "sucker-punch",
    "dark-pulse",
    "nasty-plot",
    "foul-play",
    "play-rough",
    "confide"
  ],
  "moves": [
    "bite",
    "flatter",
    "dark-pulse",
    "play-rough",
    "snatch",
    "mist-terrain",
    "sweet-kiss",
    "hyper-voice",
    "crunch",
    "lash-out",
    "heal-bell",
    "quash",
    "dark-bargain"
  ],
  "evolution_chain": {
    "id": 451,
    "item": null,
    "species": [
      {
        "name": "impidimp",
        "order": 859,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "morgrem",
        "order": 860,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 859,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "grimmsnarl",
        "order": 861,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 860,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 50,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
